import axios from "axios";
import { documentUrl, documentSearchUrl } from "../../Config/Url";
import { documentTypes } from "../../Config/DocumentTypes";

const { predispositionOut } = documentTypes;

export const predispositionService = {
  documentSearch,
  documentDelete,
  documentLock,
  getDocumentById,
  documentCreate,
  documentUpdate,
  documentDetails,
  documentCancel,
};

async function documentSearch(
  tenantId,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  searchText,
  dateFrom,
  dateTo
) {
  return axios
    .put(documentSearchUrl, {
      tenantId,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      documentTypeId: predispositionOut,
      storeId,
      searchText,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/lock`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(date, storeId, store2Id, note, products) {
  let items = products.map((item) => ({
    documentTypeId: predispositionOut,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantity),
    priceOut: item.price,
  }));

  return axios
    .post(documentUrl, {
      documentTypeId: predispositionOut,
      storeId,
      store2Id,
      date,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(
  documentGuid,
  date,
  storeId,
  store2Id,
  note,
  products
) {
  let items = products.map((item) => ({
    documentDetailGuid: item.documentDetailGuid,
    documentTypeId: predispositionOut,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantityOut),
    priceOut: item.priceOut,
    isActive: Boolean(item.isActive),
  }));

  return axios
    .put(`${documentUrl}/${documentGuid}`, {
      documentGuid,
      documentTypeId: predispositionOut,
      storeId,
      store2Id,
      date,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
async function documentDetails(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCancel(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/storno`)
    .then((res) => res)
    .catch((err) => err.response);
}
